export default {
  priv: 'pr_device',
  overviewTitle: 'Layout Rapporten',
  detailTitle: 'Layout Rapport',
  deleteTitle: 'deze layout',
  url: '/devices/reportlayouts',
  apiUrl: '/devicereportlayouts/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'reportlayouts',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  newRecord: {
    report_layout_type: 0
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/devices/reportlayouts/{id}',
      width: '30%'
    },
    {
      text: 'Bestandsnaam',
      value: 'file.name',
      width: '30%'
    },
    {
      text: 'Grootte',
      value: 'file.size',
      width: '12.5%',
      filter: 'prettyBytes'
    },
    {
      text: 'Bestand',
      value: 'file',
      width: '5%',
      type: 'file',
      align: 'center',
      sortable: false
    },
    {
      text: 'Laatste aanpassing',
      value: 'modified_timestamp',
      width: '15%',
      align: 'center',
      filter: 'timestamp'
    }
  ]
};
